import { useEffect, useState } from 'react';
import { WeaverLoading } from 'Components';
import withDetailsContainer from './withDetailsContainer';
import {
  getNodeLabel,
  getNamespaceLabel
} from 'Services/WeaverUtils';

const fetchAttributeDetails = async (data) => {
  let query = new Weaver.Query()
    .restrict(data.wvrId)
    .withAttributes();

  if (data.graph) {
    query = query.inGraph(data.graph);
  }

  const attNode = await query.first();
  return attNode
};

const AttributeNodeDetails = ({ data }) => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const result = await fetchAttributeDetails(data);
      setItem(result);
      setLoading(false);
    };

    fetchData();
  }, [data]);

  if (loading) {
    return <WeaverLoading style={{ margin: '33%' }} />;
  }

  const Details = withDetailsContainer(item, { nodeIsEditable: true });

  const staticDetails = [
    {
      key: 'from',
      label: 'From',
      value: getNodeLabel(item.fromNode),
      rowIsEditable: false,
    },
    {
      key: 'key',
      label: 'Key',
      value: getNamespaceLabel(item.key),
      rowIsEditable: false,
    },
    {
      key: 'value',
      label: 'Value',
      value: getNamespaceLabel(item.value),
      rowIsEditable: false,
    },
    {
      key: 'dataType',
      label: 'Data Type',
      value: item.dataType,
      rowIsEditable: false,
    },
  ];

  return (
    <Details>
      { staticDetails }
    </Details>
  );
};

export default AttributeNodeDetails;
